import { GenreWithCurators, MergedGenres, SimilarGenre } from '.'

const SORT_NEGATIVE = -1

const genresSorter = (arr: GenreWithCurators[]): GenreWithCurators[] =>
  [...arr].sort((a, b) => {
    if (!a?.genreName || !b?.genreName) {
      return 0
    }
    if (a?.genreName < b?.genreName) {
      return SORT_NEGATIVE
    }
    if (a?.genreName > b?.genreName) {
      return 1
    }
    return 0
  })

export const POPULAR_GENRES_WITH_SUBTITLES = [
  {
    subTitle: 'Pop',
    genres: [
      'acoustic pop',
      'afropop',
      'chill pop',
      'christian pop',
      'dream pop',
      'indie pop',
      'latin pop',
      'pop',
      'pop punk',
      'pop r&b',
      'pop reggaeton',
    ],
  },
  {
    subTitle: 'Rock & Alternative',
    genres: [
      'blues rock',
      'classic rock',
      'folk rock',
      'garage rock',
      'hard rock',
      'indie rock',
      'pop rock',
      'rock',
      'soft rock',
    ],
  },
  {
    subTitle: 'Electronic',
    genres: [
      'afro house',
      'chill house',
      'house',
      'melodic house',
      'melodic techno',
      'techno',
      'trance',
    ],
  },
  {
    subTitle: 'Hip-Hop & Rap',
    genres: [
      'alternative hip hop',
      'hip hop',
      'indie hip hop',
      'rap',
      'underground hip hop',
    ],
  },
  {
    subTitle: 'Latin & Afro',
    genres: ['latin', 'reggaeton', 'reggaeton colombiano', 'reggaeton flow'],
  },
  {
    subTitle: 'R&B & Soul',
    genres: ['chill r&b', 'r&b', 'soul'],
  },
  {
    subTitle: 'Metal & Punk',
    genres: ['alternative metal', 'metalcore', 'punk'],
  },
  {
    subTitle: 'Indie, Folk & Acoustic',
    genres: ['acoustic chill', 'christian indie', 'folk'],
  },
  {
    subTitle: 'Other / Niche',
    genres: [
      'ambient jazz',
      'bass music',
      'christian music',
      'drum and bass',
      'world soundtrack',
    ],
  },
] as const

export const mergeCampaignGenres = (
  similarGenres: SimilarGenre[],
  allGenres: GenreWithCurators[],
): MergedGenres => {
  const filteredSimilar = similarGenres.filter((item) =>
    allGenres.some((genre) => genre.id === item.id),
  )

  const filteredAllGenres = allGenres.filter(
    (genreFromAll) =>
      !filteredSimilar.some(
        (genreFromSimilar) => genreFromAll.id === genreFromSimilar.id,
      ),
  )
  const filteredRecommended = allGenres.filter((genreFromAll) =>
    filteredSimilar.some(
      (genreFromSimilar) => genreFromAll.id === genreFromSimilar.id,
    ),
  )
  return {
    recommended: genresSorter(filteredRecommended),
    allGenres: genresSorter(allGenres),
    filteredAllGenres: genresSorter(filteredAllGenres),
    popularGenres: POPULAR_GENRES_WITH_SUBTITLES.map((item) => {
      const genres = item.genres
        .map((genre) => {
          const foundGenre = allGenres.find((g) => g.genreName === genre)
          return foundGenre ? { ...foundGenre } : null
        })
        .filter(Boolean) as GenreWithCurators[]
      const visibleIds = new Set(genres.map((g) => g.id))
      const subTitleLower = item.subTitle.toLowerCase()
      const extraGenres = genresSorter(
        allGenres.filter(
          (g) =>
            !visibleIds.has(g.id) &&
            g.genreName.toLowerCase().includes(subTitleLower),
        ),
      )
      return { subTitle: item.subTitle, genres, extraGenres }
    }),
  }
}
